export default __webpack_public_path__ + "static/media/arrow.b6673de7.svg";